import { motion } from "framer-motion";
import { Sparkles, Leaf, ShieldCheck, Sun } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="mobile-shell grain" data-testid="login-page">
      <div className="relative px-6 pt-16 pb-10 bg-gradient-to-b from-[#E9F0E8] via-[#F0EFE7] to-transparent rounded-b-[40px]">
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, type: "spring" }}
          className="w-24 h-24 mx-auto mb-6 relative"
        >
          <div className="absolute inset-0 rounded-full bg-[#4A6B53]/10 blur-xl" />
          <div className="relative w-24 h-24 rounded-full bg-white flex items-center justify-center shadow-lg border border-[#E9EFEA]">
            <Leaf className="w-10 h-10 text-[#4A6B53]" strokeWidth={1.5} />
          </div>
        </motion.div>

        <motion.h1
          initial={{ y: 14, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="font-heading text-4xl text-center font-semibold tracking-tight text-[#2A332C] leading-[1.1]"
        >
          Grow your
          <br />
          <span className="italic font-light">clearest skin.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
          className="text-center text-[#6B7A70] mt-4 leading-relaxed px-2"
        >
          A 60-day garden for your Isotane journey. Tend to your daily routine, watch your plant flourish.
        </motion.p>
      </div>

      <div className="px-6 pt-6 space-y-3">
        {[
          { icon: Leaf, title: "Plant grows with you", desc: "Each completed routine adds leaves & blooms" },
          { icon: Sparkles, title: "Streaks & milestones", desc: "First Petal, Rooted, Sprouted, Blossom" },
          { icon: ShieldCheck, title: "Isotretinoin-safe", desc: "Side-effects tracker + safety reminders" },
          { icon: Sun, title: "Weekly progress selfies", desc: "Watch your skin transform over 60 days" },
        ].map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, x: -10 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 + i * 0.08 }}
            className="flex gap-4 p-4 bg-white/70 backdrop-blur rounded-2xl border border-[#E9EFEA]"
          >
            <div className="w-11 h-11 rounded-2xl bg-[#E9F0E8] flex items-center justify-center shrink-0">
              <f.icon className="w-5 h-5 text-[#4A6B53]" strokeWidth={1.5} />
            </div>
            <div>
              <div className="font-heading font-medium text-[#2A332C]">{f.title}</div>
              <div className="text-sm text-[#6B7A70]">{f.desc}</div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="px-6 mt-8 pb-12">
        <motion.button
          data-testid="google-login-btn"
          onClick={handleGoogleLogin}
          whileTap={{ scale: 0.97 }}
          className="w-full bg-[#2A332C] text-white py-4 rounded-full font-medium text-base shadow-lg hover:bg-[#4A6B53] transition-colors flex items-center justify-center gap-3"
        >
          <svg width="20" height="20" viewBox="0 0 24 24">
            <path fill="#fff" d="M21.35 11.1H12v3.2h5.35c-.23 1.42-1.68 4.16-5.35 4.16-3.22 0-5.85-2.66-5.85-5.96 0-3.3 2.63-5.96 5.85-5.96 1.83 0 3.05.78 3.75 1.45l2.56-2.46C16.86 3.95 14.65 3 12 3 6.96 3 2.87 7.04 2.87 12s4.09 9 9.13 9c5.27 0 8.76-3.7 8.76-8.92 0-.6-.07-1.05-.16-1.48z"/>
          </svg>
          Continue with Google
        </motion.button>
        <p className="text-center text-xs text-[#6B7A70] mt-4 leading-relaxed">
          Your data syncs across devices.<br/>We never share it.
        </p>
      </div>
    </div>
  );
}
